<header class="aayn-page-header">
  <h1 class="aayn-page-header--title">{{ title }}</h1>

  <p class="aayn-page-header--description">{{ description }}</p>
</header>
